import { memo } from 'react';

interface SchemaOrgProps {
  data: Record<string, unknown>;
}

const SchemaOrg = memo(function SchemaOrg({ data }: SchemaOrgProps) {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
});

export default SchemaOrg;